import React from 'react';
import { useTheme } from '../contexts/ThemeContext'; // Import useTheme hook

const Modal = ({ isOpen, onClose, children }) => {
  const { isDarkMode } = useTheme(); // Get theme state

  if (!isOpen) return null;

  return (
    <div
      className={`fixed inset-0 bg-gray-600 ${
        isDarkMode ? 'bg-opacity-75' : 'bg-opacity-50'
      } overflow-y-auto h-full w-full`}
      id="my-modal"
    >
      <div
        className={`relative top-20 mx-auto p-5 border w-96 shadow-lg rounded-md ${
          isDarkMode ? 'bg-gray-800 text-white border-gray-700' : 'bg-white text-black border-gray-300'
        }`}
      >
        <div className="mt-3 text-center">
          {children}
          <div className="items-center px-4 py-3">
            <button
              id="ok-btn"
              className={`px-4 py-2 ${isDarkMode ? 'bg-blue-700 hover:bg-blue-800' : 'bg-blue-500 hover:bg-blue-700'} text-white text-base font-medium rounded-md w-full shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-300`}
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
